export class AzureDiskEncryptionSet {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionType",
            "baseName": "encryptionType",
            "type": "AzureDiskEncryptionSetEncryptionType",
            "format": ""
        },
        {
            "name": "keyVaultName",
            "baseName": "keyVaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "keyName",
            "baseName": "keyName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDiskEncryptionSet.attributeTypeMap;
    }
    constructor() {
    }
}
